/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Cond_State_WaivedInputs */



/**
* | output |
* | --- |
* | "already waived" |
*
* @param {Partner_Billing_Board_Cond_State_WaivedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_cond_state_waived = /** @type {((inputs?: Partner_Billing_Board_Cond_State_WaivedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Cond_State_WaivedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("bereits erlassen")
	return /** @type {LocalizedString} */ ("already waived")
});